'use strict'

define ['./pagination.css'], () ->
  (RentappService, $state, $rootScope, ApplicationBundle) ->
    restrict: "E"
    template: require("./pagination.jade")
    scope:
      options: "="
      total: "@"
      state: '@'
    link: (scope, element, attrs) ->
      if !scope.options
        scope.options = 
          limit: 25
      else
        scope.options.limit = scope.options.limit or 25
      
      scope.currentPage = 1

      scope.set_start_end = () ->
        if (scope.currentPage - 1) == 0
          scope.start = 1
        else
          scope.start = (scope.currentPage - 1) * 25 + 1

        if scope.currentPage * 25 > scope.total
          scope.end = scope.total
        else
          scope.end = scope.currentPage * 25

      scope.set_start_end()

      scope.pageChanged = (action, page) ->
        scope.currentPage = page
        scope.options.offset = (page - 1) * scope.options.limit
        $rootScope.$broadcast('paginate', { offset: scope.options.offset, state: scope.state })
        scope.set_start_end()



// WEBPACK FOOTER //
// ./directives/pagination/pagination.coffee